export function useMaintenance() {
  const underMaintenance = process.env.REACT_APP_UNDER_MAINTENANCE === 'true'

  return {
    underMaintenance
  }
}
